export default __webpack_public_path__ + "static/media/radio_selected.c2f2f8cd.svg";